export default __webpack_public_path__ + "static/media/misc-books5-2048w.dcb51ab2.png";